import { render, staticRenderFns } from "./appWeekSchedule.vue?vue&type=template&id=1b0473dc&scoped=true"
import script from "./appWeekSchedule.vue?vue&type=script&lang=js"
export * from "./appWeekSchedule.vue?vue&type=script&lang=js"
import style0 from "./appWeekSchedule.vue?vue&type=style&index=0&id=1b0473dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b0473dc",
  null
  
)

export default component.exports